'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var style1 = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 3,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10
};

var PropertyProfileAppIcon = function PropertyProfileAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 58.3"
  }, props), React__default["default"].createElement("g", null, React__default["default"].createElement("polyline", {
    style: style1,
    points: "43.2,22.1 43.2,2.1 13.2,2.1 13.2,26.4 \t"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "24.2",
    y1: "56.1",
    x2: "32.2",
    y2: "56.1"
  }), React__default["default"].createElement("polygon", {
    style: style1,
    points: "2.2,38.4 13.2,32.4 24.2,38.4 24.2,56.1 2.2,56.1 \t"
  }), React__default["default"].createElement("rect", {
    x: "32.2",
    y: "28.1",
    style: style1,
    width: "22",
    height: "28"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "21.2",
    y1: "9.1",
    x2: "35.2",
    y2: "9.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "21.2",
    y1: "15.1",
    x2: "35.2",
    y2: "15.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "21.2",
    y1: "21.1",
    x2: "35.2",
    y2: "21.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "10.2",
    y1: "42.1",
    x2: "16.2",
    y2: "42.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "40.2",
    y1: "36.1",
    x2: "46.2",
    y2: "36.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "40.2",
    y1: "42.1",
    x2: "46.2",
    y2: "42.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "40.2",
    y1: "48.1",
    x2: "46.2",
    y2: "48.1"
  }), React__default["default"].createElement("line", {
    style: style1,
    x1: "10.2",
    y1: "48.1",
    x2: "16.2",
    y2: "48.1"
  })));
};

var PropertyProfileAppIcon$1 = iconStyles()(PropertyProfileAppIcon);

module.exports = PropertyProfileAppIcon$1;
